var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 0H5C3.61929 0 2.5 1.11929 2.5 2.5C1.11929 2.5 0 3.61929 0 5V17.5C0 18.8807 1.11929 20 2.5 20H11.25C12.6307 20 13.75 18.8807 13.75 17.5C15.1307 17.5 16.25 16.3807 16.25 15V2.5C16.25 1.11929 15.1307 0 13.75 0ZM13.75 16.25V5C13.75 3.61929 12.6307 2.5 11.25 2.5H3.75C3.75 1.80964 4.30964 1.25 5 1.25H13.75C14.4404 1.25 15 1.80964 15 2.5V15C15 15.6904 14.4404 16.25 13.75 16.25ZM1.25 5C1.25 4.30964 1.80964 3.75 2.5 3.75H11.25C11.9404 3.75 12.5 4.30964 12.5 5V17.5C12.5 18.1904 11.9404 18.75 11.25 18.75H2.5C1.80964 18.75 1.25 18.1904 1.25 17.5V5Z",
    fill: "#4A5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPapers);
export default __webpack_public_path__ + "static/media/ico-papers.b3daf02fc8c3438cacb5bca155a7959a.svg";
export { ForwardRef as ReactComponent };